import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';

const propTypes = {
  handleClick: PropTypes.func,
  buttonClassName: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.string
}

const SearchButton = ({ handleClick, buttonClassName, disabled, size }) => {
  const defaultButtonClasses = 'btn btn-primary'
  const buttonClasses = defaultButtonClasses + ' ' + buttonClassName
  if (handleClick) {
    return (
      <Button
        disabled={disabled}
        className={buttonClasses}
        size={size}
        variant={'primary'}
        onClick={handleClick}
      >
        <span>Search</span>
      </Button>
    )
  }
  return (
    <Button
      type='submit'
      disabled={disabled}
      className={buttonClasses}
      variant={'primary'}
      size={size}
    >
      <span>Search</span>
    </Button>
  )
}

SearchButton.propTypes = propTypes

export default SearchButton
